// extracted by mini-css-extract-plugin
module.exports = {"modal-header":"price-chart_modal-header__3K3EQ"};